import { createAction } from "@reduxjs/toolkit";
export var updateChatUser = createAction("messages/updateChatUser");
export var updateChannelMembers = createAction("messages/updateChannelMembers");
